function switchToAnotherURL () {
    if (window.location.href == "https://les-racines-du-ciel.myshopify.com/pages/revendeurs" && Weglot.getCurrentLang() == "en" ) {
        window.location.replace("https://les-racines-du-ciel.myshopify.com/pages/resellers");  
    }
    if (window.location.href == "https://les-racines-du-ciel.myshopify.com/pages/revendeurs" && Weglot.getCurrentLang() == "de" ) {
        window.location.replace("https://les-racines-du-ciel.myshopify.com/pages/wiederverkaufer");  
    }
}
Weglot.on("initialized", switchToAnotherURL);